import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { setupListeners } from '@reduxjs/toolkit/query'
import storage from 'redux-persist/lib/storage';
import {
    persistStore,
    persistReducer,
    FLUSH,
    REHYDRATE,
    PAUSE,
    PERSIST,
    PURGE,
    REGISTER,
  } from "redux-persist";

import cartReducer from '../Slices/cartSlice'
import { siteApi } from "../Apis/siteApi";
import { blogApi } from "../Apis/blogApi";
import { shopApi } from "../Apis/shopApi";
import { contactApi } from "../Apis/contactApi";

const persistConfig = {
    key: 'root',
    version: 1,
    storage,
    blacklist: [
      siteApi.reducerPath,
      blogApi.reducerPath,
      shopApi.reducerPath,
      contactApi.reducerPath
    ],
  }

const rootReducer = combineReducers({
    cart: cartReducer,
    [siteApi.reducerPath]: siteApi.reducer,
    [blogApi.reducerPath]: blogApi.reducer,
    [shopApi.reducerPath]: shopApi.reducer,
    [contactApi.reducerPath]: contactApi.reducer
})

const persistedReducer = persistReducer(persistConfig, rootReducer)

export const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
          serializableCheck: {ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER]},
      }).concat([
        siteApi.middleware,
        blogApi.middleware,
        shopApi.middleware,
        contactApi.middleware
      ]),
    // devTools: process.env.NODE_ENV !== 'production',
    devTools: false,
})

setupListeners(store.dispatch)
export const persistor = persistStore(store)